import { render } from "./TheHeaderNavigationListItem.vue?vue&type=template&id=fac03a84"
import script from "./TheHeaderNavigationListItem.vue?vue&type=script&lang=js"
export * from "./TheHeaderNavigationListItem.vue?vue&type=script&lang=js"

import exportComponent from "/opt/goodtoknow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__